<template>
  <div class="tw-flex tw-min-h-5 tw-items-center tw-justify-between tw-gap-4">
    <WdsText secondary sm class="tw-flex-none">{{ label }}</WdsText>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { WdsText } from '@worksome/wds-components'

defineProps<{ label: string }>()
</script>
